import { render, staticRenderFns } from "./selectableWizardMatchMaking.vue?vue&type=template&id=842f3720&scoped=true&"
import script from "./selectableWizardMatchMaking.vue?vue&type=script&lang=js&"
export * from "./selectableWizardMatchMaking.vue?vue&type=script&lang=js&"
import style0 from "./selectableWizardMatchMaking.vue?vue&type=style&index=0&id=842f3720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842f3720",
  null
  
)

export default component.exports